// 19.1.2.14 Object.keys(O)
var toObject = require('./$.to-object');

require('./$.object-sap')('keys', function($keys){
  return function keys(it){
    return $keys(toObject(it));
  };
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/core-js/library/modules/es6.object.keys.js
 ** module id = 1136
 ** module chunks = 0
 **/